import { ArrowBackRoundedIcon, Button } from '@shared/components';
import { useNavigate } from 'react-router-dom';

// TODO: Improve component
export function BackButton() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <Button
      variant='text'
      onClick={goBack}
      sx={{
        p: (theme) => theme.spacing(0),
        minWidth: 'auto',
        height: 'auto',
      }}
      startIcon={<ArrowBackRoundedIcon />}
    >
      Back
    </Button>
  );
}
